import { useMutation } from '@tanstack/react-query';
import ChessPaymentRestClient from '@/Api/ChessPaymentRestClient';

export interface SelectedSlot {
  date: string;
  time: string;
}

export interface SelectedBatch {
  batch_name: string;
  batch_code: string;
  coach_name: string;
  class_timing: string;
  class_days: string;
  start_date: string;
  tournament_id: number;
  level_name: string | null;
}

interface CreateRenewalOrderParams {
  tournament_id: number;
  plan_type: 'personal' | 'group' | 'webinar';
  duration_months: number;
  coupon_code?: string;
  selectedSlots?: SelectedSlot[];
  selectedBatch?: SelectedBatch | null;
  timezone?: string;
  customer_id: number;
  mobile_number: string;
  email: string;
  return_url: string;
  amount?: number; // Grand total amount calculated on frontend
  selected_pricing_id?: number; // Pricing ID from selected pricing entry
  category_str?: string; // Optional category string for CSOC payments
}

export default function useCreateRenewalOrder(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: any) => void,
) {
  const mutation = useMutation<any, Error, CreateRenewalOrderParams>(
    async body => {
      // For now, we'll use the existing payment flow
      // The backend will handle renewal-specific logic
      // Prepare batch_details for data payload
      // If batch is selected, include batch_name and batch_display_name
      // Otherwise, send empty object {} (not empty string "")
      let batchDetails = {};
      if (body.selectedBatch?.batch_name) {
        batchDetails = {
          batch_name: body.selectedBatch.batch_name,
          batch_display_name: body.selectedBatch.batch_name, // Frontend can send batch_display_name if available
        };
      }

      const response = await ChessPaymentRestClient.post(
        'v1/generate_payment_links',
        {
          tournament_id: body.tournament_id,
          customer_id: body.customer_id,
          mobile_number: body.mobile_number,
          email: body.email,
          player_id: body?.player_id,
          return_url: body.return_url,
          category_str: body.category_str || `INR /${body.duration_months}-Months`, // Format: "INR /3-Months" to match backend API category format
          amount: body.amount, // Send calculated amount from frontend
          batch_details: batchDetails, // Always send {} instead of "" for empty case
          renewal_metadata: {
            plan_type: body.plan_type,
            duration_months: body.duration_months,
            coupon_code: body.coupon_code,
            selected_slots: body.selectedSlots || [],
            selected_batch: body.selectedBatch || null,
            timezone: body.timezone || 'Asia/Kolkata',
            selected_pricing_id: body.selected_pricing_id,
          },
        },
      );
      return response.data;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
      onError: error => {
        if (handleOnError) {
          handleOnError(error);
        }
      },
    },
  );

  return {
    ...mutation,
  };
}




